<template>
    <div class="operateSuccess">
        <div class="operateSuccess-con">
            <div class="imgCuccess">
                <img src="../../../images/sucessDialog.png" alt="">
                <p>报价已提交</p>
            </div>
            <div class="text">住逻辑将在<span>24小时</span>生成报价结果，请您耐心等待</div>
            <div class="buttonSuccess">
                <button class="back"><router-link :to="'/home/product/list/' + $route.query.orderId">返回产品详情页</router-link></button>
                <button class="go"><router-link :to="'/my/detailedList/operate?id=' + $route.query.detailedListId">前往清单结算</router-link></button>
            </div>
        </div>
        <!--相似的产品-->
        <div class="detail-similar list" v-if="similarities.length > 0">
            <div class="similar-title">
                <span>相似产品</span>
            </div>
            <MyWaterfall :list="similarities" type="product" @load="loadMore"></MyWaterfall>
        </div>
    </div>
</template>
<script>
    import api from '../../../api';
    import MyWaterfall from '../../common/my-waterfall';
    export default{
        data() {
            return {
                similarities: [],
                filter: {
                    pageNum: 1,
                    productId: this.$route.query.orderId,
                    pageSize: 12
                },
                busy: false,
            }
        },
        components: {MyWaterfall},
        methods:{
            updateList() {
                this.busy = true;
                api.products.getSimilarities(this.filter)
                    .then(res => {
                        this.similarities = this.similarities.concat(res);
                        this.total = res.total;
                        this.busy = false;
                    }, () => {
                        this.busy = false;
                    });
            },
            loadMore() {
                if (this.filter.pageNum * this.filter.pageSize < this.total) {
                    this.filter.pageNum++;
                    this.updateList();
                }
            },
        },
        created(){
            this.updateList();
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .operateSuccess{
        text-align: center;
        .operateSuccess-con{
            min-width: 1220px;
            padding: 78px 0 65px 0;
            margin: 0 auto;
            background: #fff;
            .imgCuccess{
                width: 100%;
                text-align: center;
                img{
                    width: 120px;
                    height: 120px;
                    margin-bottom: 24px;
                }
                p{
                    font-size: 20px;
                    color: #353838;
                    text-align: center;
                    margin-bottom: 22px;
                }
            }
            .text{
                width: 100%;
                text-align: center;
                font-size: 14px;
                color: #000000;
                margin-bottom: 22px;
                span{
                    color:#E14B5D;
                    font-size: 14px;
                }
            }
            .buttonSuccess{
                width: 100%;
                text-align: center;
                button.back{
                    border: 2px solid #308697;
                    border-radius: 4px;
                    height: 40px;
                    width: 120px;
                    text-align: center;
                    line-height: 40px;
                    font-size: 14px;
                    color: #308697;
                    margin-right: 10px;
                    background: #FFFFFF;
                    &:hover{
                        opacity: 0.8;
                    }
                }
                button.go{
                    background: #308697;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFFFFF;
                    height: 40px;
                    width: 120px;
                    text-align: center;
                    line-height: 40px;
                    &:hover{
                        opacity: 0.8;
                    }
                }
            }
        }
        /*相似*/
        .detail-similar.list {
            clear: both;
        }

        .detail-similar.list .white-btn {
            margin: 30px auto;
            border: 2px solid #DCE0E0;
            width: 228px;
            height: 40px;
            line-height: 36px;
            color: #6C6F70;
            display: block;
        }

        .detail-similar.list .similar-title {
            text-align: left;
            font-size: 16px;
            margin-left: 10px;
            margin-top: 68px;
        }

        .detail-similar.list .similar-content .content-img {
            width: 15%;
            height: auto;
            margin-top: 10px;
            float: left;
            margin-right: 15px;
        }

        .detail-similar.list .similar-content .content-img img {
            width: 100%;
            height: 100%;
        }
    }
</style>